import type { FunctionComponent, ReactElement } from "react"

import { Text } from "@jobteaser/spark/components/Text"

import styles from "./TrSection.module.css"

type TrSectionProps = {
  title: string
  length: number
}

export const TrSection: FunctionComponent<TrSectionProps> = ({ title, length }) => {
  const renderTitle = (): ReactElement => {
    if (title.length > 0) {
      return (
        <th className={styles.thCell} scope="colgroup">
          <Text variant="title3" weight="bold" className={styles.colGroupTitle}>
            {title}
          </Text>
        </th>
      )
    }

    return (
      <th className={styles.thEmptyCell}>
        <hr />
      </th>
    )
  }

  return (
    <tr className={styles.main}>
      {renderTitle()}
      {Array.from({ length }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <td className={styles.tdEmptyCell} key={index}>
          <hr />
        </td>
      ))}
    </tr>
  )
}
